import * as React from 'react';
import { useSelector } from 'react-redux';
import { State } from 'reducers';
import { getScheduleForDevice } from 'selectors/schedulesSelectors';
import { useTranslation } from 'react-i18next';

export type Props = {
    deviceId: string;
    onClick(): void;
};

const pointerStyle = {
    cursor: 'pointer',
};

export const ScheduleColumn = ({ onClick, ...props }: Props) => {
    const { t } = useTranslation();
    const schedule = useSelector((state: State) => getScheduleForDevice(state, props));
    return (
        <span onClick={ onClick } style={ pointerStyle }>
            { (!schedule || schedule.rules.length === 0 || !schedule.rules[0].themeId) &&
                <i
                    className="red delete calendar icon"
                    title={ t("DEVICES.NO_SCHEDULE") }
                />
            }
        </span>
    );
};
